module.exports = __webpack_public_path__ + "img/recognition_img.3f475392.png";